import * as React from 'react';
import Styled from 'styled-components';

import BaseButton from './BaseButton';
import { IButtonProps } from './common';
import { PrimaryActive, PrimaryDisabled } from './ButtonStyles';

const DisabledButton = Styled(BaseButton) <IButtonProps>`
  ${PrimaryDisabled}
`;

const ActiveButton = Styled(BaseButton) <IButtonProps>`
  ${PrimaryActive}
`;

export const PrimaryButton: React.FunctionComponent<IButtonProps> = props => (
  props.disabled && !props.isLoading ? <DisabledButton {...props} /> : <ActiveButton {...props} />
);

PrimaryButton.defaultProps = {
  disabled: false,
};

export default PrimaryButton;
